export enum MaskTool {
  MAGIC_WAND_ADD = 'MAGIC-WAND-ADD', 
  MAGIC_WAND_SUB = 'MAGIC-WAND-SUB',
  MASK_ONLY = 'MASK-ONLY',
  PAINT = 'PAINT',
  ERASE = 'ERASE',
  PAN = 'PAN'
}
